import { getStore } from '@/util/store'
import generateId from '@/util/generate'
import { appAccess } from '@/utils/auth'
import { saveCourse, getUserSubject, curriculumSetCreateFun } from '@/api/index-bei'

/**
 * 应用权限校验
 * @param alias 应用名
 * @param isInstitution 是否判断机构有权限
 * @returns {Promise<*>}
 */
const routeAuth = async (alias, isInstitution) => {
  return new Promise((resolve, reject) => {
    appAccess(alias)
      .then((res) => {
        const result = res.data.data
        // not_given 机构没有开通 not_access 用户没有权限 not_found 未知的应用 access 应用可访问
        if (isInstitution && ['not_access', 'access'].some((element) => element === result.result)) {
          return resolve(true)
        }
        if (result.userIsGod) {
          resolve(true)
        }

        if (!result.result) return reject(false)
        if (result.result !== 'access') return reject(false)
        if (result.memberStatus !== 0 && result.memberStatus !== null) return reject(false)
        if (result.userStatus !== 0) return reject(false)

        resolve(true)
      })
      .catch((err) => {
        reject(false)
      })
  })
}
const userAuth = async () => {
  // 机构资源管理和校本库权限
  return Promise.all([routeAuth('orgSourceManage', true), routeAuth('schoolSourceLib', true)])
    .then((res) => {
      return [res]
    })
    .catch((err) => {
      return [err]
    })
}

// 新建学程
export const createCourse = () => {
  const accessInfo = getStore({ name: 'accessInfo' })
  const periodAndsubject = {
    periodDictItemCode: '',
    periodDictItemName: '',
    subjectDictItemCode: '',
    subjectDictItemName: '',
  }
  if (accessInfo.accountType < 2 && accessInfo.memberType.includes('teacher')) {
    getUserSubject(accessInfo.user_id).then((res) => {
      const data = res.data.data
      if (data?.periodDictItemCode) {
        periodAndsubject.periodDictItemCode = data.periodDictItemCode
        periodAndsubject.periodDictItemName = data.periodDictItemName
      }
      if (data?.subjectDictItemCode) {
        periodAndsubject.subjectDictItemCode = data.subjectDictItemCode
        periodAndsubject.subjectDictItemName = data.subjectDictItemName
      }
      toCourse(periodAndsubject)
    })
  } else {
    toCourse(periodAndsubject)
  }
}

const saveCourseMtd = (data) => {
  return new Promise((resolve) => {
    saveCourse(data).then((res) => {
      if (res.data.code === 0) {
        resolve(res.data.data)
      }
    })
  })
}
const envList = ['dev', 'test', 'pre']
const env_name =
  envList.find((v) => {
    return location.host.includes(v)
  }) || ''

const toCourse = async (periodAndsubject) => {
  const _auth = await userAuth()
  const hasFalse = _auth.every((element) => element === false)
  const canvasId = generateId()
  const data = {
    attribute: {
      bgType: 1,
      bgData: '',
      bgSet: 3,
    },
    catalog: {
      resourceTypeDictItemCode: 'nation',
      resourceOwnership: !hasFalse ? 'school_lib' : 'resource_lib',
      ...periodAndsubject,
    },
    canvas: {
      id: canvasId,
      width: 1176,
      height: 1664,
      sort: 1,
      elements: [
        {
          canvasId: canvasId,
          id: generateId(),
          elementType: 'title',
          elementContent: {
            content:
              '<p style="text-align: center;"><strong><span style="font-size: 48px;">请输入学程名称（必填）</span></strong></p>',
            width: 1076,
            height: 94,
            x: 50,
            y: 80,
            r: 0,
            layer: 10,
            title: {
              style: 'none',
              text: '请输入学程名称（必填）',
            },
          },
          sort: 1,
          isHidden: false,
        },
      ],
      attribute: {
        bgType: 1,
        bgData: '',
        bgSet: 3,
      },
    },
  }
  const sendId = await saveCourseMtd(data)
  const token = getStore({ name: 'access_token' })
  // 编辑返回的路由菜单
  const returnTo = `&returnTo=${encodeURIComponent('inspirationCentre?inspirationCentre=/course')}`
  const queryUrl = `?from=course&type=edit&courseId=${sendId}&version=2&autyType=2&token=${token}${returnTo}`
  const openUrl = env_name
    ? `//${env_name}course.zhixuehuijiao.cn${queryUrl}`
    : `//edu-course.zhixuehuijiao.cn${queryUrl}`
  // https://dev-educourse.zhixuehuijiao.cn/?from=course&type=edit&courseId=1847119022996320257&version=2&autyType=2&token=68ccceba-9dd6-46fc-a0f2-525291eb8e08&returnTo=inspirationCentre%3FinspirationCentre%3D%2Fcourse
  console.log('创建学程', openUrl)
  window.open(openUrl, '_blank')
}

// 前往编辑
export const goEdit = async (item) => {
  const accessInfo = getStore({ name: 'accessInfo' })
  if (item.creatingStatus === 1) {
    await curriculumSetCreateFun(item.id)
  }
  // 编辑返回的路由菜单
  const returnTo = `&returnTo=${encodeURIComponent('bei')}`
  const queryUrl = `?from=course&type=edit&courseId=${item.id}&version=2&autyType=2&token=${accessInfo.access_token}${returnTo}`
  location.reload()
  const openUrl = env_name
    ? `//${env_name}course.zhixuehuijiao.cn${queryUrl}`
    : `//edu-course.zhixuehuijiao.cn${queryUrl}`
  window.open(openUrl, '_top')
}

// 前往预览
export const previewCourse = (item) => {
  const accessInfo = getStore({ name: 'accessInfo' })
  let id = item.id
  if (item.courseVersion === 2) {
    let autyType = item.courseVersion
    let queryUrl = `/preview?courseId=${id}&autyType=${autyType}&version=2&token=${accessInfo.access_token}`
    if (item.status === 1) queryUrl = queryUrl + '&isStored=1' // 已入库参数
    const url = env_name
      ? `//${env_name}course.zhixuehuijiao.cn${queryUrl}`
      : `//edu-course.zhixuehuijiao.cn${queryUrl}`
    window.open(url)
  } else {
    // 旧学程预览页
    window.open(`/courseDetail?id=${id}&source=${item.source || 2}&accountType=${accessInfo?.accountType}`)
  }
}

/**
 * 应用权限与跳转
 */
export const getAppUrl = async (applyName) => {
  if (applyName) {
    try {
      const res = await appAccess(applyName)
      const { data, code } = res.data
      if (code === 0) {
        const { result, userStatus, memberStatus, app } = data
        const state = result === 'access' && userStatus === 0 && memberStatus === 0
        if (state) {
          const { url: appUrl } = app
          // 判断url 里是否包含https和http
          return appUrl.includes('http') ? appUrl : `${window.location.protocol}${appUrl}`
        } else {
          return null
        }
      }
    } catch (error) {
      return null
    }
  } else {
    return null
  }
}

// 学科网权限判断
export const getXkwUrl = () => {
  const accessInfo = getStore({ name: 'accessInfo' })
  const userInfo = getStore({ name: 'userInfo' })
  const url = '/api/admin/xkwOauth/authentication?state=' + userInfo.id
  if (!accessInfo.createPhone || (!env_name && userInfo.institutionCode === 'EQYE')) {
    return null
  } else {
    return url
  }
}

/**
 * 关联的标签跳转编辑
 * @param value
 */
export const jumpEdit = async (value) => {
  const accessInfo = getStore({ name: 'accessInfo' })
  switch (value.citeResType) {
    case 0: {
      // 新课程
      const commonName = env_name ? `//${env_name}web.zhixuehuijiao.cn` : `//web.zhixuehuijiao.cn`
      window.open(
        `${commonName}/inspirationCentre?inspirationCentre=%2Fsub-inspiration-centre-svc%2FeditLesson%3Fid%3D${value.resId}`,
      )
      break
    }
    case 1: {
      // 新学程
      // if (item.creatingStatus === 1) { // 如果学程已完成，点击编辑改为创作中
      await curriculumSetCreateFun(value.resId)
      // }
      // 编辑返回的路由菜单
      const returnTo = `&returnTo=${encodeURIComponent('inspirationCentre?inspirationCentre=/practice')}`
      const queryUrl = `?from=course&type=edit&courseId=${value.resId}&version=2&autyType=2&token=${accessInfo.access_token}${returnTo}&exerciseId=${value.practiceId}`
      const openUrl = env_name
        ? `//${env_name}course.zhixuehuijiao.cn${queryUrl}`
        : `//edu-course.zhixuehuijiao.cn${queryUrl}`
      window.open(openUrl)
      break
    }
  }
}
